<template lang="pug">
  li.v-multiselect__options-item(
    :class="{ 'v-multiselect__options-item--selected': isSelected }"
    @click="onClick")
    span {{ item[itemName] | translate }}
    span.v-multiselect__options-item--subtitle(
      v-if="itemSubname") {{ item[itemSubname] | translate }}
</template>

<script>
export default {
  name: 'VMultiselectItem',

  props: {
    comparator: Function,
    selected: Array,
    item: Object,
    itemName: String,
    itemSubname: String,
    itemValue: String
  },

  methods: {
    onClick () {
      const item = this.itemValue
        ? this.item[this.itemValue]
        : this.item
      if (this.isSelected) {
        this.$emit('unselect', item)
      } else {
        this.$emit('select', item)
      }
    }
  },

  computed: {
    isSelected () {
      return this.selected
        .some(el => this.comparator
          ? this.comparator(el, this.item)
          : this.itemValue
            ? el === this.item[this.itemValue]
            : el.id === this.item.id)
    }
  }
}
</script>